/* Gifting module - vanilla JS port (no jQuery dependency) of the live theme's gifting_module.js. Same behaviour. */
(function(){
function init(){
  document.querySelectorAll('.gifting_module .radio').forEach(function(r){
    r.addEventListener('click',function(){
      document.querySelectorAll('.gifting_module .radio').forEach(function(x){x.classList.remove('selected');});
      r.classList.add('selected');
      document.querySelectorAll('.gift_options').forEach(function(o){o.style.display = r.classList.contains('yes') ? 'flex' : 'none';});
    });
  });
  document.querySelectorAll('.gift_options li').forEach(function(li){
    if(li.dataset.giftBound){return;} li.dataset.giftBound='1';
    li.setAttribute('tabindex','0'); li.setAttribute('role','button');
    var toggle=function(){ li.classList.toggle('selected'); li.setAttribute('aria-pressed', li.classList.contains('selected')); atcFunc(li); };
    li.addEventListener('click',function(e){ e.preventDefault(); toggle(); });
    li.addEventListener('keydown',function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); toggle(); } });
  });
}
function post(url,body,msg){
  fetch(url,{method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded','Accept':'application/json'},body:body})
    .then(function(r){return r.json();})
    .then(function(){console.log(msg);})
    .catch(function(){console.log('error handling here');});
}
function atcFunc(li){
  var id=li.id, n=parseInt(li.getAttribute('data-id'))||0;
  if(li.classList.contains('selected')){
    li.setAttribute('data-id',n+1);
    post('/cart/add','quantity=1&id='+id,'Product Added to Cart, new count is '+n);
  } else {
    n=n-1; li.setAttribute('data-id',n);
    post('/cart/change','quantity='+n+'&id='+id,'Product removed from Cart, new count is '+n);
  }
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);} else {init();}
})();
